import React, {useEffect} from 'react';
import {Platform} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {useQueryParam, StringParam} from 'use-query-params';

import {initRemoteConfig} from 'store/app/remoteConfigActions';
import {initDynamicLinkHandler} from 'store/app/linkActions';
import {initCache} from 'store/app/cacheActions';
import {
  setLegacyFlag,
  setDirectLanding,
  setReadyToMove,
  setAvatarURL,
  setCustomCourse,
} from 'store/meeting/actions/meeting';
import {setCurrentUnitId} from './store/course';
import TrialDemo from 'components/TrialDemo/TrialDemo';

const RemoteConfigHandler = () => {
  const dispatch = useDispatch();
  const isRemoteConfigLoaded = useSelector(
    state => state.app.isRemoteConfigLoaded,
  );

  useEffect(() => {
    if (Platform.OS === 'web') {
      if (!isRemoteConfigLoaded) {
        dispatch(initRemoteConfig());
      }
    }
  }, [isRemoteConfigLoaded]); // Add token to dependencies to ensure correctness

  // Web breaks for some reason using useEffect to call this
  console.log('RemoteConfigHandler', Date.now());

  return <></>;
};
const IntialLink = () => {
  const dispatch = useDispatch();
  const [token] = useQueryParam('token', StringParam);
  const [avatarSelectionString] = useQueryParam('avatarSelection', StringParam);
  const [legacyString] = useQueryParam('legacy', StringParam);
  const [avatarUrlString] = useQueryParam('avatarUrl', StringParam);
  const [customCourseString] = useQueryParam('customCourse', StringParam);
  const [showTrialDemo] = useQueryParam('showTrialDemo', StringParam);
  const [showLVDemo] = useQueryParam('showLVDemo', StringParam);

  // avatarSelection
  if (Platform.OS === 'web' && token) {
    const avatarSelection = false;//avatarSelectionString === 'true'; // 'true' becomes true, everything else becomes false
    const legacy = legacyString === 'false' ? false : true; //If we explicitly passed a legacy param as false only then it is false otherwise by default it is true
    if (avatarUrlString) {
      dispatch(setAvatarURL(`${avatarUrlString}`));
    }
    const customCourse = customCourseString === 'true';
    dispatch(setDirectLanding(!avatarSelection));
    dispatch(setCustomCourse(customCourse));
    dispatch(setReadyToMove(false));
    dispatch(setLegacyFlag(legacy));
    // Always executes once for web; demo flags are used by web link handler to optionally load demo content.
    dispatch(initDynamicLinkHandler(token, avatarSelection, showTrialDemo, showLVDemo));
    return <></>;
  }

  // Trial demo entry point (web): if we have demo params but no token, run the TrialDemo flow
  if (Platform.OS === 'web' && (showTrialDemo || showLVDemo)) {
    return (
      <TrialDemo
        loading={true}
        showTrialDemo={showTrialDemo}
        showLVDemo={showLVDemo}
      />
    );
  }

  return <></>;
};
export default () => {
  return (
    <>
      <RemoteConfigHandler />
      <IntialLink />
    </>
  );
};
